export const phoneFormats = {
  "11": "+ # ### ### ## ##",
  "12": "+ # ### ### ### ##"
};

export const phoneMasks = {
  "11": "# ### ### ## ##",
  "12": "# ### ### ### ##"
};